import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './../../../services/API/auth/auth.service';
import { NotificationServiceService } from './../../../services/notification-service/notification-service.service';
import { AuxiliarService } from './../../../services/auxiliar.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedGuard  {

  constructor(
    private router: Router,
    private notificationService: NotificationServiceService,
    private authService: AuthService,
    private auxiliarService: AuxiliarService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isLogged = this.authService.isLogged();
    if (!isLogged) {
      this.notificationService.openSnackBar('Tu sesión ha expirado');
      this.router.navigate(['/login']);
      return false;
    }

    return this.auxiliarService.ensureSocketUrlLoaded().then(() => true);
  }

}
